// const OSM_DATA_SERVICE_URL = 'https://overpass.private.coffee/api/interpreter'; // Main Overpass API instance You can safely assume that you don't disturb other users when you do less than 10,000 queries per day and download less than 1 GB data per day
const OSM_DATA_SERVICE_URL = 'https://maps.mail.ru/osm/tools/overpass/api/interpreter';
//const OSM_DATA_SERVICE_URL = 'https://overpass.private.coffee/api/interpreter';

const OVERPASS_SETTINGS = '[out:json][timeout:120]';

const MAX_RETRIES = 3;
const INITIAL_RETRY_DELAY_MS = 1000;

const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

/**
 * appelle l'API Overpass et relance automatiquement en cas d'erreur serveur (5xx, ex: 504 Gateway Timeout)
 * avec un délai exponentiel entre chaque tentative
 */
const fetchOverpass = async (url, retries = MAX_RETRIES, delay = INITIAL_RETRY_DELAY_MS) => {
  const response = await fetch(url);
  if (!response.ok) {
    if (response.status >= 500 && response.status < 600 && retries > 0) {
      await sleep(delay);
      return fetchOverpass(url, retries - 1, delay * 2);
    }
    throw new Error(`Overpass API error: ${response.status}`);
  }
  const data = await response.json();
  if (data.remark) {
    console.warn('Overpass remark:', data.remark);
    throw new Error(data.remark);
  }
  return data;
};

export const osmSearch = {
  /**
   * Récupère toutes les routes potentiellement concernées par les trottoirs.
   * Le découpage theoretical / noSidewalk se fait côté client.
   */
  searchRoads: (osmID) => {
    const areaID = 3600000000 + osmID;
    const url = `${OSM_DATA_SERVICE_URL}?data=${OVERPASS_SETTINGS};area(${areaID})->.a;(way(area.a)[highway~"^(living_street|residential|primary|secondary|tertiary)$"];);out geom;`;
    return fetchOverpass(url);
  },

  /**
   * Récupère tous les trottoirs (dessinés + renseignés via tag sidewalk).
   * Le découpage drawn / described / describedBoth se fait côté client.
   */
  searchSidewalks: (osmID, startDate) => {
    const areaID = 3600000000 + osmID;
    const dateFilter = startDate ? `(newer:"${startDate}")` : '';
    const url = `${OSM_DATA_SERVICE_URL}?data=${OVERPASS_SETTINGS};area(${areaID})->.a;(way(area.a)[highway="footway"][footway="sidewalk"]${dateFilter};way(area.a)[sidewalk="left"]${dateFilter};way(area.a)[sidewalk="right"]${dateFilter};way(area.a)[sidewalk="both"]${dateFilter};way(area.a)["sidewalk:left"="yes"]${dateFilter};way(area.a)["sidewalk:right"="yes"]${dateFilter};);out geom;`;
    return fetchOverpass(url);
  },

  /**
   * Récupère tous les chemins piétons et passages piétons.
   * Le découpage walkPath / walkCyclePath / crossingPoint / crossingPath se fait côté client.
   */
  searchPathsAndCrossings: (osmID, startDate) => {
    const areaID = 3600000000 + osmID;
    const dateFilter = startDate ? `(newer:"${startDate}")` : '';
    const url = `${OSM_DATA_SERVICE_URL}?data=${OVERPASS_SETTINGS};area(${areaID})->.a;(way(area.a)[highway~"^(footway|pedestrian|living_street|path|track|steps)$"][footway!~"^(sidewalk|crossing)$"]${dateFilter};way(area.a)[highway="cycleway"][foot~"^(yes|designated|permissive)$"]${dateFilter};node(area.a)[highway="crossing"]${dateFilter};way(area.a)[highway="footway"][footway="crossing"]${dateFilter};);out geom;`;
    return fetchOverpass(url);
  },
};

const convertBbox = (bbox) => {
  if (bbox) {
    const { _ne, _sw } = bbox;
    const north = _ne.lat;
    const east = _ne.lng;
    const south = _sw.lat;
    const west = _sw.lng;
    return { south, west, north, east };
  } else {
    return undefined;
  }
};

export const osmSearchByBbox = {
  /**
   * Récupère toutes les routes potentiellement concernées par les trottoirs (par bbox).
   */
  searchRoads: (bbox) => {
    const { south, west, north, east } = convertBbox(bbox);
    const url = `${OSM_DATA_SERVICE_URL}?data=${OVERPASS_SETTINGS};(way[highway~"^(living_street|residential|primary|secondary|tertiary)$"](${south}, ${west}, ${north}, ${east}););out geom;`;
    return fetchOverpass(url);
  },

  /**
   * Récupère tous les trottoirs (par bbox).
   */
  searchSidewalks: (bbox, startDate) => {
    const { south, west, north, east } = convertBbox(bbox);
    const dateFilter = startDate ? `(newer:"${startDate}")` : '';
    const url = `${OSM_DATA_SERVICE_URL}?data=${OVERPASS_SETTINGS};(way[highway="footway"][footway="sidewalk"](${south}, ${west}, ${north}, ${east})${dateFilter};way[sidewalk="left"](${south}, ${west}, ${north}, ${east})${dateFilter};way[sidewalk="right"](${south}, ${west}, ${north}, ${east})${dateFilter};way[sidewalk="both"](${south}, ${west}, ${north}, ${east})${dateFilter};way["sidewalk:left"="yes"](${south}, ${west}, ${north}, ${east})${dateFilter};way["sidewalk:right"="yes"](${south}, ${west}, ${north}, ${east})${dateFilter};);out geom;`;
    return fetchOverpass(url);
  },

  /**
   * Récupère tous les chemins piétons et passages piétons (par bbox).
   */
  searchPathsAndCrossings: (bbox, startDate) => {
    const { south, west, north, east } = convertBbox(bbox);
    const dateFilter = startDate ? `(newer:"${startDate}")` : '';
    const url = `${OSM_DATA_SERVICE_URL}?data=${OVERPASS_SETTINGS};(way[highway~"^(footway|pedestrian|living_street|path|track|steps)$"][footway!~"^(sidewalk|crossing)$"](${south}, ${west}, ${north}, ${east})${dateFilter};way[highway="cycleway"][foot~"^(yes|designated|permissive)$"](${south}, ${west}, ${north}, ${east})${dateFilter};node[highway="crossing"](${south}, ${west}, ${north}, ${east})${dateFilter};way[highway="footway"][footway="crossing"](${south}, ${west}, ${north}, ${east})${dateFilter};);out geom;`;
    return fetchOverpass(url);
  },
};
